import script from "./EmailSettingPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSettingPreferences.vue?vue&type=script&setup=true&lang=ts"

import "./EmailSettingPreferences.vue?vue&type=style&index=0&id=24d262cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d262cc"]])

export default __exports__